import apiService from '../api';

export interface FoodCategory {
  id: string;
  tenantId: string;
  companyId: string;
  name: string;
  description?: string;
  icon?: string;
  color?: string;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    foodItems: number;
  };
}

export interface FoodItem {
  id: string;
  tenantId: string;
  companyId: string;
  categoryId: string;
  name: string;
  description?: string;
  defaultPrice?: number;
  isAvailable: boolean;
  image?: string;
  preparationTime?: number;
  createdAt: string;
  updatedAt: string;
  category?: {
    id: string;
    name: string;
    icon?: string;
    color?: string;
  };
}

export interface CreateFoodCategoryInput {
  name: string;
  description?: string;
  icon?: string;
  color?: string;
  sortOrder?: number;
  isActive?: boolean;
}

export interface UpdateFoodCategoryInput extends Partial<CreateFoodCategoryInput> {}

export interface CreateFoodItemInput {
  categoryId: string;
  name: string;
  description?: string;
  defaultPrice?: number;
  isAvailable?: boolean;
  image?: string;
  preparationTime?: number;
  companyId?: string;
}

export interface UpdateFoodItemInput extends Partial<CreateFoodItemInput> {}

export const foodApi = {
  // Food Categories
  getCategories: async (companyId?: string): Promise<FoodCategory[]> => {
    const url = companyId ? `/food-categories?companyId=${encodeURIComponent(companyId)}` : '/food-categories';
    const response = await apiService.get(url);
    return response;
  },

  getCategory: async (id: string): Promise<FoodCategory> => {
    const response = await apiService.get(`/food-categories/${id}`);
    return response;
  },

  createCategory: async (data: CreateFoodCategoryInput): Promise<FoodCategory> => {
    const response = await apiService.post('/food-categories', data);
    return response;
  },

  updateCategory: async (id: string, data: UpdateFoodCategoryInput): Promise<FoodCategory> => {
    const response = await apiService.put(`/food-categories/${id}`, data);
    return response;
  },

  deleteCategory: async (id: string): Promise<void> => {
    await apiService.delete(`/food-categories/${id}`);
  },

  // Food Items
  getFoodItems: async (categoryId?: string, companyId?: string): Promise<FoodItem[]> => {
    const searchParams = new URLSearchParams();
    if (categoryId) searchParams.append('categoryId', categoryId);
    if (companyId) searchParams.append('companyId', companyId);
    
    const queryString = searchParams.toString();
    const url = queryString ? `/food-items?${queryString}` : '/food-items';
    const response = await apiService.get(url);
    return response;
  },

  getFoodItem: async (id: string): Promise<FoodItem> => {
    const response = await apiService.get(`/food-items/${id}`);
    return response;
  },

  createFoodItem: async (data: CreateFoodItemInput): Promise<FoodItem> => {
    const response = await apiService.post('/food-items', data);
    return response;
  },

  updateFoodItem: async (id: string, data: UpdateFoodItemInput): Promise<FoodItem> => {
    const response = await apiService.put(`/food-items/${id}`, data);
    return response;
  },

  deleteFoodItem: async (id: string): Promise<void> => {
    await apiService.delete(`/food-items/${id}`);
  },
};
